export default "{\n    \"yes\": \"Sí\",\n    \"no\": \"No\"\n}"